module.exports = __webpack_public_path__ + "static/media/top-img_6@2x.b3d9ce64.jpg";